/** For Media Devoted | Created By Ciro Autiero */

export function orDash(v: string | string[] | null | undefined): string {
  if (v == null) return '—';
  if (Array.isArray(v)) return v.length ? v.join(', ') : '—';
  return String(v || '').trim() || '—';
}
